<!-- 提示弹层 -->
<template>
  <div class="tips" v-show="tips.show">
    <h3 v-html="tips.title"></h3>
  </div>
</template>
<script>
export default {
  name: 'tips',
  data () {
    return {
      // 可以根据实际情况写更复杂的弹层，根据情况扩充tips即可
      tips: {
        show: false,
        title: ''
      }
    }
  },
  created () {
    this.bus.$on('tips', (data) => {
      this.tips = data
    })
  },
  watch: {
    // 检测tips变化，显示提示1.5s之后自动关闭，可根据实际情况自动修改时间
    tips: function () {
      if (this.tips.show) {
        setTimeout(() => {
          this.tips.show = false
        }, this.tips.duration)
      }
    }
  }
}
</script>
<style scoped lang='less'>
.tips{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  color: #fff;
  transition: all 0.3s;
  h3{
    padding: 0.2rem 0.3rem;
    font-size: 0.28em;
    max-width: 6rem;
    line-height: 1.4;
    background-color: rgba(0,0,0,0.6);
    border-radius: 0.1rem;
  }
}
/*横屏less*/
@media screen and (min-width: 600px) {
  .tips{
    h3{
      font-size: 0.3rem
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/tips.vue